var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"donutChartTitulo",attrs:{"type":"pie","height":"350","layout":"compact","options":_vm.apexChatData.donutChartTitulo.chartOptions,"series":_vm.apexChatData.donutChartTitulo.series}})}
var staticRenderFns = []

export { render, staticRenderFns }